import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { DocumentItemModel } from '../document/document-item.model';

@CopyMetadataFromParent()
export class SaleDocumentItemModel extends DocumentItemModel {
    @Property()
    public cost: number;

    @Property(String, {nullable: true})
    public jpkVatProcedure: string | null;

    @Property()
    public unitCost: number;

    @Property()
    public relatedInventoryItemsIds: number[];

    @Property()
    public includesInventoryControl: boolean;
}
